import { createSlice } from '@reduxjs/toolkit';

const loadState = () => {
  const defaultState = {
    collapsedSidebar: false,
    openSidebarDrawer: false,
  };

  try {
    const serializedState = localStorage.getItem('collapsedSidebar');
    if (serializedState === null) {
      return defaultState;
    }
    const storedState = JSON.parse(serializedState) as boolean;
    defaultState.collapsedSidebar = storedState;
    return defaultState;
  } catch {
    return defaultState;
  }
};

const saveCollapsedSidebar = (collapsed: boolean) => {
  try {
    localStorage.setItem('collapsedSidebar', JSON.stringify(collapsed));
  } catch {
    // empty
  }
};

const dashboardSlice = createSlice({
  name: 'dashboard_store',
  initialState: loadState(),
  reducers: {
    setCollapsedSidebar(state, action: { payload: boolean }) {
      state.collapsedSidebar = action.payload;
      saveCollapsedSidebar(action.payload);
    },
    setOpenSidebarDrawer(state, action: { payload: boolean }) {
      state.openSidebarDrawer = action.payload;
    },
  },
});

const { actions, reducer } = dashboardSlice;

export const { setOpenSidebarDrawer, setCollapsedSidebar } = actions;
export { reducer };
